export enum State {
    CZ = 'CZ',
    SK = 'SK',
    AF = 'AF',
    AX = 'AX',
    AL = 'AL',
    DZ = 'DZ',
    AS = 'AS',
    VI = 'VI',
    AD = 'AD',
    AO = 'AO',
    AI = 'AI',
    AQ = 'AQ',
    AG = 'AG',
    AR = 'AR',
    AM = 'AM',
    AW = 'AW',
    AU = 'AU',
    AZ = 'AZ',
    BS = 'BS',
    BH = 'BH',
    BD = 'BD',
    BB = 'BB',
    BE = 'BE',
    BZ = 'BZ',
    BY = 'BY',
    BJ = 'BJ',
    BM = 'BM',
    BT = 'BT',
    BO = 'BO',
    BQ = 'BQ',
    BA = 'BA',
    BW = 'BW',
    BV = 'BV',
    BR = 'BR',
    IO = 'IO',
    VG = 'VG',
    BN = 'BN',
    BG = 'BG',
    BF = 'BF',
    BI = 'BI',
    TD = 'TD',
    ME = 'ME',
    CL = 'CL',
    HR = 'HR',
    CN = 'CN',
    CK = 'CK',
    CW = 'CW',
    DK = 'DK',
    DM = 'DM',
    DO = 'DO',
    DJ = 'DJ',
    EG = 'EG',
    EC = 'EC',
    ER = 'ER',
    EE = 'EE',
    ET = 'ET',
    FO = 'FO',
    FK = 'FK',
    FJ = 'FJ',
    PH = 'PH',
    FI = 'FI',
    FR = 'FR',
    GF = 'GF',
    TF = 'TF',
    PF = 'PF',
    GA = 'GA',
    GM = 'GM',
    GH = 'GH',
    GI = 'GI',
    GD = 'GD',
    GL = 'GL',
    GE = 'GE',
    GP = 'GP',
    GU = 'GU',
    GT = 'GT',
    GG = 'GG',
    GN = 'GN',
    GW = 'GW',
    GY = 'GY',
    HT = 'HT',
    HM = 'HM',
    HN = 'HN',
    HK = 'HK',
    IN = 'IN',
    ID = 'ID',
    IQ = 'IQ',
    IR = 'IR',
    IE = 'IE',
    IS = 'IS',
    IT = 'IT',
    IL = 'IL',
    JM = 'JM',
    JP = 'JP',
    YE = 'YE',
    JE = 'JE',
    ZA = 'ZA',
    GS = 'GS',
    SS = 'SS',
    JO = 'JO',
    KY = 'KY',
    KH = 'KH',
    CM = 'CM',
    CA = 'CA',
    CV = 'CV',
    QA = 'QA',
    KZ = 'KZ',
    KE = 'KE',
    KI = 'KI',
    CC = 'CC',
    CO = 'CO',
    KM = 'KM',
    CD = 'CD',
    CG = 'CG',
    KP = 'KP',
    KR = 'KR',
    XK = 'XK',
    CR = 'CR',
    CU = 'CU',
    KW = 'KW',
    CY = 'CY',
    KG = 'KG',
    LA = 'LA',
    LS = 'LS',
    LB = 'LB',
    LR = 'LR',
    LY = 'LY',
    LI = 'LI',
    LT = 'LT',
    LV = 'LV',
    LU = 'LU',
    MO = 'MO',
    MG = 'MG',
    HU = 'HU',
    MK = 'MK',
    MY = 'MY',
    MW = 'MW',
    MV = 'MV',
    ML = 'ML',
    MT = 'MT',
    MA = 'MA',
    MH = 'MH',
    MQ = 'MQ',
    MU = 'MU',
    MR = 'MR',
    YT = 'YT',
    UM = 'UM',
    MX = 'MX',
    FM = 'FM',
    MD = 'MD',
    MC = 'MC',
    MN = 'MN',
    MS = 'MS',
    MZ = 'MZ',
    MM = 'MM',
    NA = 'NA',
    NR = 'NR',
    DE = 'DE',
    NP = 'NP',
    NE = 'NE',
    NG = 'NG',
    NI = 'NI',
    NU = 'NU',
    NL = 'NL',
    NO = 'NO',
    NC = 'NC',
    NZ = 'NZ',
    OM = 'OM',
    IM = 'IM',
    NF = 'NF',
    MP = 'MP',
    TC = 'TC',
    PK = 'PK',
    PW = 'PW',
    PS = 'PS',
    PA = 'PA',
    PG = 'PG',
    PY = 'PY',
    PE = 'PE',
    PN = 'PN',
    CI = 'CI',
    PL = 'PL',
    PR = 'PR',
    PT = 'PT',
    AT = 'AT',
    GR = 'GR',
    RE = 'RE',
    GQ = 'GQ',
    RO = 'RO',
    RU = 'RU',
    RW = 'RW',
    BL = 'BL',
    PM = 'PM',
    SB = 'SB',
    SV = 'SV',
    WS = 'WS',
    SM = 'SM',
    SA = 'SA',
    SN = 'SN',
    SC = 'SC',
    SL = 'SL',
    SG = 'SG',
    SI = 'SI',
    SO = 'SO',
    ES = 'ES',
    AE = 'AE',
    GB = 'GB',
    US = 'US',
    RS = 'RS',
    LK = 'LK',
    CF = 'CF',
    SD = 'SD',
    SR = 'SR',
    SJ = 'SJ',
    SH = 'SH',
    LC = 'LC',
    KN = 'KN',
    MF = 'MF',
    SX = 'SX',
    VA = 'VA',
    ST = 'ST',
    VC = 'VC',
    SZ = 'SZ',
    SE = 'SE',
    CH = 'CH',
    SY = 'SY',
    TJ = 'TJ',
    TZ = 'TZ',
    TW = 'TW',
    TH = 'TH',
    TG = 'TG',
    TK = 'TK',
    TO = 'TO',
    TT = 'TT',
    TN = 'TN',
    TR = 'TR',
    TM = 'TM',
    TV = 'TV',
    UG = 'UG',
    UA = 'UA',
    UY = 'UY',
    UZ = 'UZ',
    CX = 'CX',
    VU = 'VU',
    VE = 'VE',
    VN = 'VN',
    TL = 'TL',
    WF = 'WF',
    ZM = 'ZM',
    EH = 'EH',
    ZW = 'ZW'
}
